<template>
  <div class="mainPage">
    <p id="headPage">Daftar Perlengkapan</p>
    <div class="cardRow">
      <div class="inRow">
        <div class="card" id="balanceCard">
          <p id="titleCard">Total Sparepart</p>
          <p id="amountCard">{{formatUang(totalBalance)}}</p>
        </div>
        <div class="card" id="outCard">
          <p id="titleCard">Barang Rusak</p>
          <p id="amountCard">{{formatUang(barangRusak)}}</p>
        </div>
        <div class="card" id="outCard">
          <p id="titleCard">Barang Hilang</p>
          <p id="amountCard">{{formatUang(barangHilang)}}</p>
        </div>
      </div>
    </div>
    <div id="titleRow">
      <b-button id="addModal" @click.prevent="showAdd()">Tambah Data</b-button>
    </div>
    <div class="filterRow">
      <div class="inRow">
        <div class="inCol" id="cardFilter">
          <p id="inputTitle">Status Barang</p>
          <b-select v-model="statusIn" @change="this.getDataTable">
            <option value="0">Seluruh</option>
            <option value='tersedia'>Tersedia</option>
            <option value='keluar'>Keluar</option>
          </b-select>
        </div>
        <div class="inCol" id="cardFilter">
          <p id="inputTitle">Status</p>
          <b-select v-model="filter.status" @change="this.getDataTable">
            <option value="">Seluruh Barang</option>
            <option v-for="(e,index) in this.statuses" :key="index">{{ e }}</option>
          </b-select>
        </div>
        <div class="inCol" id="cardFilter">
          <p id="inputTitle">Kata Kunci</p>
          <b-input v-model="filter.keyword" @change="this.getDataTable"></b-input>
        </div>
      </div>
    </div>
    <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p> 
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div>
    <div class="tableRow">
      <div class="inRow">
        <lord-icon
          v-if="this.isLoading"
          src="https://cdn.lordicon.com/dpinvufc.json"
          trigger="loop"
          style="width:300px;height:300px">
        </lord-icon>
      </div>
      <table v-if="!isLoading" class="table-bordered table-hover" id="tableData">
        <thead>
          <tr>
            <th>Kode</th>
            <th>Nama </th>
            <th>Type </th>
            <th>Nilai</th>
            <th>Status</th>
            <th>Tersedia </th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="e in this.dataTable" :key="e.id">
            <!-- <td>{{ e }}</td> -->
            <td>{{ e.code }}</td>
            <td> {{e.name}} </td>
            <td> {{e.type}} </td>
            <td class="text-right">{{ formatUang(e.amount) }}</td>
            <td>{{ e.status }}</td>
            <td style="background-color: #FF6961;" v-if="!e.statusIn"></td>
            <td style="background-color: #76B947;" v-if="e.statusIn"></td>
            <td id="action" class="text-center" >
              <button @click.prevent="showIn('in',e.id)" v-if="!e.statusIn">
                <lord-icon
                  src="https://cdn.lordicon.com/ytgufzvb.json"
                  colors="primary:#121331,secondary:#e83a30"
                  trigger="hover">
                </lord-icon>
              </button>
              <button @click.prevent="showIn('out', e.id)" v-if="e.statusIn">
                <lord-icon
                  src="https://cdn.lordicon.com/ytgufzvb.json"
                  trigger="hover">
                </lord-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination mt-2">
        <button type="button" class="mr-1" id="pageButton" v-if="currentPage > 1"  @click.prevent="minPage()"> &lt; </button>
        <button class="mr-1" id="pageButton" v-if="currentPage <= 1"  > &lt; </button>
        <p class="mr-1"> {{this.currentPage}} </p>
        <p class="mr-1">/</p>
        <p class="mr-1">{{this.totalPage}} </p> 
        <button type="button" id="pageButton" v-if="this.currentPage < this.totalPage" @click.prevent="addPage()"> > </button>
        <button id="pageButton" v-if="this.currentPage >= this.totalPage" > > </button>
      </div>
    </div>

    <!-- modal -->
  <div class="modal" id="inOutModal" tabindex="-1">
  <!-- <div class="modal-dialog"> -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" v-if="this.inOut.type == 'in'">Inventaris Masuk</h5>
        <h5 class="modal-title" v-if="this.inOut.type == 'out'">Inventaris Keluar</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="isEdit ? editData() : addInOut()">

          <div class="inRow">
            <div class="inCol">
              <p id="titleModal">Tanggal</p>
              <b-input v-model="inOut.date" type="date" required ></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">Jam</p>
              <b-input v-model="inOut.time" type="time" required ></b-input>
            </div>
            <div class="inCol" v-if="this.inOut.type == 'in'">
              <p id="titleModal">Status</p>
              <b-select v-model="inOut.status" @change="this.getDataTable">
                <option value="">Seluruh Barang</option>
                <option v-for="(e,index) in this.statuses" :key="index">{{ e }}</option>
              </b-select>
            </div>
            <div class="inCol">
              <p id="titleModal">notes</p>
              <b-input v-model="inOut.notes"  required></b-input>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary"> {{ isEdit ? 'Edit' : 'Tambah' }} </button>
        </div>
      </form>
      </div>
    </div>
  <!-- </div> -->
</div>
<!-- mainModal -->
  <div class="modal" id="mainModal" tabindex="-1">
  <!-- <div class="modal-dialog"> -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Nama Inventaris</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" >&times; </span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="isEdit ? addInOut() : addData()">

          <div class="inRow">
            <div class="inCol">
              <p id="titleModal">Cabang</p>
              <b-select v-model="add.BranchId" required>
                <option v-for="e in this.branches" :key="e.id" :value="e.id"> {{e.branchName}} </option>
              </b-select>
            </div>
            <div class="inCol">
              <p id="titleModal">Nama Barang</p>
              <b-input v-model="add.name" required ></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">Type</p>
              <b-input v-model="add.type" required ></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">Detail</p>
              <b-input v-model="add.detail"  ></b-input>
            </div>
            <div class="inCol">
              <p id="titleModal">Nilai </p>
              <b-input v-model="add.amount"  @input="currencyNumber($event)" class="text-right"  type="text" required></b-input>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="submit" class="btn btn-primary"> {{ isEdit ? 'Edit' : 'Tambah' }} </button>
        </div>
      </form>
      </div>
    </div>
  <!-- </div> -->
</div>

<!-- Vehicle -->

  </div>
</template>

<script>
import axios  from '../API/axios'
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment'
import html2pdf from "html2pdf.js";

export default {
  name: "Voucer",
  data() {
    return  {
      id: 0,
      dataTable: [],
      currentPage: 1,
      perPage: 40,
			totalPage : 1,
      isLoading: false,
      isEdit: false,
      totalBalance: 0,
      barangBaik: 0,
      barangRusak: 0,
      barangHilang: 0,
      barangOut: 0,
      statuses: ['baik','rusak','hilang'],
      
      add: {
        BranchId: 0,
        name: '',
        type: '',
        detail: '',
        amount: 0
      },
      inOut: {
        BranchId: 0,
        date: '',
        time: '',
        notes: '',
        type: '',
        status: ''
      },
      print: {
        refNo: '',
        date: '',
        invCode: '',
        invName: '',
        dateOut: '',
        timeOut: '',
        noteOut: '',
        dateIn: '',
        timeIn: '',
        noteIn: '',
        status: ''

      },
      // filter
      filter: {
        keyword: '',
        status: ''
      },
      statusIn: "0",
      produckName: "",
      type: "",
    }
  },
  created() {
    this.getDataTable()
    this.$store.dispatch("getBranch")
  },
  computed: {
    branches() {
      return this.$store.state.branches
    }
  },  
  methods: {

    showAdd() {
      this.isEdit = false
      this.produckName = ""
      this.type = ""
      $('#mainModal').modal('show')
    },

    showIn(type,id) {
      this.id = id
      this.inOut.type = type
      $('#inOutModal').modal('show')
    },


    async getDataTable() {
      this.isLoading = true
      try {
        
        let {data} = await axios({
          method: "GET",
          url: "/inventory",
          headers: {
            access_token: localStorage.getItem("access_token")
          },
          params: {
            page: this.currentPage,
            limit: this.perPage,
            keyword: this.filter.keyword,
            statusIn: this.statusIn,
            status: this.filter.status
          }
        })
        this.dataTable = data.data2.result
        this.totalBalance = data.totalBalance
        this.barangRusak = data.barangRusak
        this.barangBaik = data.barangBaik
        this.barangHilang = data.barangHilang
        this.barangOut = data.barangOut
        let totalPage = Math.ceil(data.data2.dataLength / this.perPage)
				this.totalPage = totalPage
        this.isLoading = false
      } catch(err) {
        this.isLoading = false
        console.log(err);
      }

    },


    async addData() {

      try {
        
        let proses = await axios({
          method: "POST",
          url: "/inventory",
          data: {
            name : this.add.name,
            BranchId : this.add.BranchId,
            type : this.add.type,
            detail : this.add.detail,
            amount : this.add.amount.trim().split('.').filter(e => e != '.' ).join(''),
          },
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        this.add.name = "",
        this.add.type = "",
        this.add.detail = "",
        this.getDataTable()
        $('#mainModal').modal('hide')
        Swal.fire('Berhasil', 'Telah diproses', 'success');
      } catch(err) {
        console.log(err);
        this.isLoading = false
      }
    },

    async addInOut() {

      try {
        
        
        let proses = await axios({
          method: "POST",
          url: `/inventory/out/${this.id}`,
          data: this.inOut,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        this.inOut= {
          BranchId: 0,
          date: '',
          time: '',
          notes: '',
          type: ''
        },
        this.getDataTable()
        $('#inOutModal').modal('hide')
        Swal.fire('Berhasil', 'Telah diproses', 'success');
      } catch(err) {
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
        console.log(err);
        this.isLoading = false
      }
    },
    async editData(e) {

      try {

        let payload = {
            name : this.add.name,
            type : this.add.type,
            detail : this.add.detail,
        }

        let data2 = await axios({
          method: "put",
          url: `/sparepart/${this.id}`,
          data: payload,
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })



        $('#mainModal').modal('hide')
        this.add.name = "",
        this.add.type = "",
        this.add.detail = "",
        this.id=  0
        this.isEdit = false
        this.getDataTable()
        Swal.fire('Berhasil', 'Data Berhasil Diubah', 'success');
        
      } catch(err) {
        console.log(err);
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');
      }
    },

    testButton() {
      alert("ok")
    },

    async deleteData(id) {
      
      try {
        
        let data = await axios.delete(`/sparepart/${id}`, {
          headers: {
            access_token: localStorage.getItem("access_token")
          },
        })
        Swal.fire('Berhasil', 'Data Berhasil Dihapuskan', 'success');
        this.$store.dispatch("getBranch")
        this.getDataTable()
      } catch(err) {
        Swal.fire('Maaf', 'Periksa Kembali data anda', 'error');

      } 
    },
    async confirmDelete(id) {
      
      try {
        let data = await Swal.fire({
            title: 'Yakin?',
            text: 'Apakah Yakin ',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Hapus!!',
        })
        if (data.isConfirmed) { 
            await this.deleteData(id);
            this.$store.dispatch("getBranch")
            this.getDataTable()
        } else {
                Swal.fire('Ok', 'Proses anda berhasil dibatalkan', 'error');
              }
              
              
            } catch(err) {
              
              Swal.fire('Maaf', 'Proses anda berhasil dibatalkan', 'error');
      }
    },
    currencyNumber(event, target) {
        console.log(event, "===================");
        let currentValue = event.trim().split('.').filter(e => e != '.' ).join('')

        console.log(currentValue, typeof currentValue," -----------");
        if( Number.isNaN(Number(currentValue))) {
          // this.amount = 10
          this.add.amount = this.formatUang(currentValue.split('').filter(e => !Number.isNaN( Number(e))).join(''))
          return
        }
        // currentValue = this.add.amount
        this.add.amount = this.formatUang(currentValue)
        // currentValue = this.amount
        // this.amount = this.amount.toLocaleString('id-ID')
        console.log(this.add.amount, "++++++++++++++");
    },

    formatUang(data) {
      // console.log(data);
			let uang = "";
      if(data) {
        data = data.toString();
        for (let i = 0; i < data.length; i++) {
          if ((data.length - i) % 3 == 0 && i !== 0) {
          uang += `.${data[i]}`;
          } else {
          uang += data[i];
          }
        }
      }
      return uang
    },

    addPage() {
      this.currentPage = this.currentPage + 1
          this.getDataTable()
    },
    minPage() {
      this.currentPage = this.currentPage - 1
          this.getDataTable()
    },
  }
}
</script>

<style scoped>
  .cardRow {
    /* display: flex; */
    width: 100%;
    /* background-color: aqua; */
  }



 




</style>